export default __webpack_public_path__ + "static/media/icon_download.fbb60f4c.svg";